export const iconFontAwesomeWritingQuoteLeft = (
	<i className="fa-solid fa-quote-left"></i>
);
